import "rxjs/add/operator/toPromise";

import { Injectable } from "@angular/core";
import { File } from "@ionic-native/file";
import { Api } from "../api/api";

@Injectable()
export class Utility {
  buildApk  = false;
  debugMode = false;

  constructor(private file: File, private api: Api) { }

  getFolderUpload_server() {
    return this.api.url + "/upload";
  }

  config_activity(get) {
    let config = [];
    config.push("url_upload", this.api.url + "/upload/activity/");
    return config[get];
  }

  getDirMyRadiant() {
    this.file
      .checkDir(this.file.externalRootDirectory, "MyRadiant")
      .then((a) => { })
      .catch((e) => {
        this.file.createDir(this.file.externalRootDirectory, "MyRadiant", true);
      });
    return this.file.externalRootDirectory + "MyRadiant/";
  }
}



// WEBPACK FOOTER //
// ./src/providers/resources/utility.ts